import { Checkbox } from '@/shared/ui/checkbox';
import { Label } from '@/shared/ui/label';

interface PublicInviteMarketingConsentProps {
  /** Canais de marketing que a loja contratou; sem nenhum, não mostra nada. */
  channels?: { email: boolean; sms: boolean };
  organizationName: string;
  email: boolean;
  sms: boolean;
  onEmailChange: (checked: boolean) => void;
  onSmsChange: (checked: boolean) => void;
}

/**
 * Aceite de e-mail/SMS marketing no cadastro. As caixas começam desmarcadas e
 * não são obrigatórias: o aceite tem de ser uma escolha da pessoa. Marcar ou
 * não vira `privacy.PROMOEMAIL/PROMOTELEFONE` no cadastro, que é o que o envio
 * de e-mail/SMS marketing confere.
 */
export function PublicInviteMarketingConsent({
  channels,
  organizationName,
  email,
  sms,
  onEmailChange,
  onSmsChange,
}: PublicInviteMarketingConsentProps) {
  if (!channels || (!channels.email && !channels.sms)) return null;
  const store = organizationName.trim() || 'a loja';

  return (
    <div className="space-y-2.5">
      {channels.email ? (
        <div className="flex items-start gap-3">
          <Checkbox
            id="invite-marketing-email"
            checked={email}
            onCheckedChange={(value) => onEmailChange(value === true)}
            className="mt-0.5"
          />
          <Label htmlFor="invite-marketing-email" className="text-sm font-normal leading-snug text-muted-foreground">
            Quero receber ofertas e novidades de {store} por e-mail.
          </Label>
        </div>
      ) : null}
      {channels.sms ? (
        <div className="flex items-start gap-3">
          <Checkbox
            id="invite-marketing-sms"
            checked={sms}
            onCheckedChange={(value) => onSmsChange(value === true)}
            className="mt-0.5"
          />
          <Label htmlFor="invite-marketing-sms" className="text-sm font-normal leading-snug text-muted-foreground">
            Quero receber ofertas e novidades de {store} por SMS. Para sair, é só responder SAIR.
          </Label>
        </div>
      ) : null}
    </div>
  );
}
